import { useMemo } from "react";
import { useFormContext } from "@jti/ui/components/Form";
import { useStockStatuses } from "../../../../hooks/useStockStatuses";
import { useConsumablesProductDetailsContext } from "../../../../providers/ConsumablesProductDetailsProvider";
import { getStockStatusesForBundleItems } from "../../../../utils/getOptions";
import { getSiblingItemsStockStatus } from "../../../../utils/getSiblingItemsStockStatus";
export const useConsumablesStockStatuses = () => {
    const { currentMatrixItem, consumablesProductDetailsComponentData } = useConsumablesProductDetailsContext();
    const { items: consumables } = consumablesProductDetailsComponentData.consumablesMatrixData;
    const form = useFormContext();
    const purchaseTypeInputValue = form.watch("purchaseType");
    const currentPackagingFormatId = form.watch("packagingFormatId");
    const currentPackagingFormat = form.watch("packagingFormat");
    const categoriesSKUList = useMemo(() => {
        return consumables
            .filter((item) => item.packagingFormatId === currentPackagingFormatId && item.purchaseType === purchaseTypeInputValue)
            .map((item) => item.sku);
    }, [consumables, purchaseTypeInputValue, currentPackagingFormatId, currentMatrixItem]);
    const selectStocksStatuses = (data) => {
        if (currentPackagingFormat?.contentsType === "mixed" && data.products.items[0]) {
            return getStockStatusesForBundleItems(data.products.items[0]);
        }
        return getSiblingItemsStockStatus(data);
    };
    const result = useStockStatuses({
        categoriesSKUList,
        select: selectStocksStatuses,
    });
    return result;
};
//# sourceMappingURL=useConsumablesStockStatuses.js.map